import { useMemo } from "react"
import { useBasketQuantitiesContext, useWholesalerBasketQuantitiesContext } from "@bundles/parts/components/ListV2/ContextProvider/BasketQuantities"
import { useShowArticleDetails } from "@bundles/parts/components/ListV2/hooks"
import { CarouselActions } from "./CarouselActionsContext"

export function useCarouselActions(): CarouselActions {
    const showArticleDetails = useShowArticleDetails()
    const { updateBasketQuantities } = useBasketQuantitiesContext()
    const { updateBasketQuantities: updateWholesalerBasketQuantities } = useWholesalerBasketQuantitiesContext() ?? {}

    return useMemo<CarouselActions>(
        () => ({
            showArticleDetails,
            updateBasketQuantities,
            updateWholesalerBasketQuantities,
        }),
        [showArticleDetails, updateBasketQuantities, updateWholesalerBasketQuantities]
    )
}
